import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  fetchContentV2TrendingHashtags,
} from '../../services/mp-cf-api-service';

const fetchContentV2TrendingHashtagsByLanguage = () => {
  const [ trendingHashtagsData, setTrendingHashtagsData ] = useState({ });
  const [ fetchData, setFetchData ] = useState(null);
  const {
    languageCode,
    onOperationComplete,
  } = fetchData || {};

  const fetchTrendingHashtags = async () => {
    try {
      console.log(`Fetching trending hashtags for languageCode : ${languageCode}`);
      setTrendingHashtagsData({
        isFetching: true,
        isError: false,
      });

      const trendingHashtagsApiResp =  await fetchContentV2TrendingHashtags({
        data: {
          language_code: languageCode,
        },
      });
      let errorMsg = null;
      let isError = false;

      if(trendingHashtagsApiResp.success) {
        console.log(`Fetching trending hashtags for language : ${languageCode} Success!!`);
      } else {
        console.log(`Fetching trending hashtags for language : ${languageCode} Failed!!`);
        errorMsg = `Failed to fetch trending hashtags`;
        isError = true;
      }

      setTrendingHashtagsData({
        data: trendingHashtagsApiResp.data,
        isFetching: false,
        isError,
        errorMsg,
      });

      if(onOperationComplete) {
        onOperationComplete({
          data: trendingHashtagsApiResp.data,
          isError: false,
          errorMsg,
        });
      }
    } catch (err) {
      console.log(`Error while fetching trending hashtags from RTDB for language : ${languageCode}. Error : ${err}`);
      const errorMsg = `Error occurred while fetching hashtags from RTDB for language : ${languageCode}.`;
      setTrendingHashtagsData({
        data: null,
        isFetching: false,
        isError: true,
        errorMsg,
      });
      if(onOperationComplete) {
        onOperationComplete({
          data: null,
          isError: true,
          errorMsg,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(fetchData)) {
      fetchTrendingHashtags();
    }
  }, [ fetchData ]);

  return [
    trendingHashtagsData,
    setFetchData,
  ];
};

export default fetchContentV2TrendingHashtagsByLanguage;
